/**
 * AuthRequiredModal - Shown when a feature requires authentication
 */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './AuthRequiredModal.css';

const AuthRequiredModal = ({ isOpen, onClose }) => {
  const { redirectToAuth } = useAuth();

  if (!isOpen) return null;

  const handleLogin = () => {
    redirectToAuth('login');
  };

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      ></div>

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-lock me-2"></i>
                Connexion requise
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body text-center">
              <div className="auth-required-icon">
                <i className="bi bi-cloud-arrow-up"></i>
              </div>
              <p className="auth-required-message">
                Connectez-vous pour sauvegarder vos tournois et y accéder depuis n'importe quel appareil.
              </p>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleLogin}
              >
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Se connecter
              </button>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={onClose}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthRequiredModal;
